import React, { FC } from 'react'

import cx from 'classnames'
import { isEmpty, propOr } from 'ramda'

import Link from 'components/Link'
import { forDesktop } from 'decorators/device'
import { setAnalyticsProps } from 'helpers/metaTags'

import s from './Breadcrumbs.scss'

interface IBreadcrumbType {
  link?: boolean
  pathname: string
  title: string
}

interface IBreadcrumbs {
  items: IBreadcrumbType[]
}

const Breadcrumbs: FC<IBreadcrumbs> = ({ items = [] }) => {
  const renderBreadcrumb = (item: IBreadcrumbType, key: string, index: number) => {
    const pathname: string = propOr('', 'pathname', item)
    const notLink = item.link === false || isEmpty(pathname)
    const Tag = notLink ? 'span' : Link
    const to = notLink ? '' : { pathname }
    return (
      <li
        key={key}
        className={s.breadcrumbs__item}
        itemProp='itemListElement'
        itemScope
        itemType='https://schema.org/ListItem'
      >
        <meta itemProp='position'
          content={String(index + 1)} />
        <meta itemProp='name'
          content={item.title} />
        <Tag
          className={cx(s.breadcrumbs__link, {
            [s.breadcrumbs__text]: notLink
          })}
          to={to}
          itemProp='item'
          {...setAnalyticsProps({
            type: 'action',
            group: 'navigation',
            pos: 'breadcrumbs'
          })}
        >
          {item.title}
        </Tag>
      </li>
    )
  }

  if (typeof items === 'undefined') {
    return null
  }

  return (
    <div className={s.breadcrumbs}>
      <ul
        className={s.breadcrumbs__list}
        itemScope
        itemType='https://schema.org/BreadcrumbList'
      >
        {items.map((item, i) => renderBreadcrumb(item, item.pathname, i))}
      </ul>
    </div>
  )
}

export default forDesktop(Breadcrumbs)
